import React from 'react';
import { TextField, Typography, CircularProgress, Grid, Checkbox } from '@material-ui/core';

const InfosBasicas = ({
  formData,
  setFormData,
  distributors,
  loadingDistributors,
  handleDistributorToggle,
  classes,
  fieldErrors,
  validateField,
}) => {
  return (
    <div className={classes.sectionGap}>
      <TextField
        label="Nome do Plano"
        value={formData.name}
        onChange={e => {
          const newFormData = { ...formData, name: e.target.value };
          setFormData(newFormData);
          validateField('name', e.target.value, newFormData);
        }}
        onBlur={() => validateField('name', formData.name)}
        placeholder="Ex: Plano Padrão 2024"
        required
        fullWidth
        variant="outlined"
        error={!!fieldErrors?.name}
        helperText={fieldErrors?.name || ''}
      />

      <TextField
        label="Descrição"
        value={formData.description}
        onChange={e => setFormData({ ...formData, description: e.target.value })}
        placeholder="Ex: Comissionamento por performance de 60% a 100%"
        fullWidth
        variant="outlined"
        multiline
        minRows={3}
      />

      <div>
        <Typography variant="subtitle1" style={{ fontWeight: 600, marginBottom: 8 }}>
          Distribuidoras
        </Typography>
        <Typography variant="caption" color="textSecondary" style={{ marginBottom: 16, display: 'block' }}>
          Selecione as distribuidoras que terão acesso a este plano de comissionamento
        </Typography>
        {fieldErrors?.distributorIds && (
          <Typography variant="caption" color="error" style={{ marginBottom: 8, display: 'block' }}>
            {fieldErrors.distributorIds}
          </Typography>
        )}
        {!loadingDistributors && distributors.length > 0 && (
          <div
            role="button"
            tabIndex={0}
            onClick={() => {
              const allSelected = formData.distributorIds.length === distributors.length;
              const newDistributorIds = allSelected ? [] : distributors.map(d => d.id);
              const newFormData = { ...formData, distributorIds: newDistributorIds };
              setFormData(newFormData);
              validateField('distributorIds', newDistributorIds, newFormData);
            }}
            onKeyDown={e => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                const allSelected = formData.distributorIds.length === distributors.length;
                const newDistributorIds = allSelected ? [] : distributors.map(d => d.id);
                const newFormData = { ...formData, distributorIds: newDistributorIds };
                setFormData(newFormData);
                validateField('distributorIds', newDistributorIds, newFormData);
              }
            }}
            style={{
              cursor: 'pointer',
              transition: 'all 0.2s',
              border: '1px solid #e0e0e0',
              backgroundColor: 'white',
              borderRadius: '4px',
              padding: '8px 12px',
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              marginBottom: 8,
            }}
          >
            <Checkbox
              checked={formData.distributorIds.length === distributors.length && distributors.length > 0}
              indeterminate={formData.distributorIds.length > 0 && formData.distributorIds.length < distributors.length}
              size="small"
              onClick={e => e.stopPropagation()}
              onChange={e => {
                if (e.target.checked) {
                  setFormData({ ...formData, distributorIds: distributors.map(d => d.id) });
                } else {
                  setFormData({ ...formData, distributorIds: [] });
                }
              }}
              style={{ padding: '4px', color: '#FF5246' }}
            />
            <Typography variant="body2" style={{ fontWeight: 600 }}>
              Todas
            </Typography>
          </div>
        )}
        {loadingDistributors ? (
          <div style={{ textAlign: 'center', padding: 32 }}>
            <CircularProgress size={40} />
            <Typography variant="body2" color="textSecondary" style={{ marginTop: 16 }}>
              Carregando distribuidoras...
            </Typography>
          </div>
        ) : (
          <Grid container spacing={1}>
            {distributors.map(dist => {
              const isSelected = formData.distributorIds.includes(dist.id);
              return (
                <Grid item xs={12} sm={6} md={4} lg={3} key={dist.id}>
                  <div
                    role="button"
                    tabIndex={0}
                    onClick={() => handleDistributorToggle(dist.id, !isSelected)}
                    onKeyDown={e => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        handleDistributorToggle(dist.id, !isSelected);
                      }
                    }}
                    style={{
                      cursor: 'pointer',
                      transition: 'all 0.2s',
                      border: isSelected ? '2px solid #FF5246' : '1px solid #e0e0e0',
                      backgroundColor: isSelected ? 'rgba(255, 82, 70, 0.08)' : 'white',
                      borderRadius: '4px',
                      padding: '8px 12px',
                      display: 'flex',
                      alignItems: 'center',
                      gap: 8,
                    }}
                  >
                    <Checkbox
                      checked={isSelected}
                      size="small"
                      onClick={e => e.stopPropagation()}
                      onChange={e => handleDistributorToggle(dist.id, e.target.checked)}
                      style={{ padding: '4px', color: isSelected ? '#FF5246' : '#bdbdbd' }}
                    />
                    <Typography variant="body2" style={{ fontWeight: isSelected ? 600 : 400 }}>
                      {dist.name}
                    </Typography>
                  </div>
                </Grid>
              );
            })}
          </Grid>
        )}
      </div>
    </div>
  );
};

export default InfosBasicas;
